import { INTERNAL_CLIENT_ID } from '../../constants';
import { insertPhase, updatePhase } from '../../services/phases';
import { notify } from '../../store/feedback';
import { uid } from '../../utils/format';
import { getPhaseById, withCancellation } from '../../utils/phases';
import { currentDeals, syncLineDates } from '../deals/lineDatesSync';
import { phaseFromForm, phaseRow } from './phaseRows';

/* Fiche d'une phase : création (client Interne seulement) ou modification. Une phase issue d'une
   affaire convertie garde les montants de l'affaire ; ses dates sont reportées sur la ligne vendue. */
export default function phaseSaveHandlers(deps, api) {
  const { appState, closeModal, deals, form, modalData, setDeals, update } = deps;

  const setClientPhases = (change) =>
    update((s) => ({
      ...s,
      clients: s.clients.map((c) =>
        c.id === modalData.clientId ? { ...c, phases: change(c.phases) } : c,
      ),
    }));

  async function savePhaseForm(fact, isEdit) {
    if (!form.nom) return;
    if (!isEdit && modalData.clientId !== INTERNAL_CLIENT_ID)
      return void notify("Toute nouvelle phase doit venir d'une affaire CRM convertie.");
    const current = isEdit ? getPhaseById(appState.clients, modalData.phaseId)?.phase : null;
    const phData = phaseFromForm(form, fact, !!current?.ligneId);
    if (isEdit) {
      await updatePhase(phaseRow(phData), modalData);
      // La fiche porte la fin prévue ; une phase annulée garde sa date d'annulation pour les calculs.
      setClientPhases((phases) =>
        phases.map((ph) =>
          ph.id === modalData.phaseId
            ? withCancellation({ ...ph, ...phData }, phData.dateFin, ph.annuleeLe || null)
            : ph,
        ),
      );
      const allDeals = await currentDeals(deals, api);
      await syncLineDates({ deals: allDeals, setDeals }, current, phData.dateDebut, phData.dateFin);
    } else {
      const newPhId = uid();
      await insertPhase(phaseRow(phData), modalData, newPhId);
      setClientPhases((phases) => [...phases, { id: newPhId, briques: [], ...phData }]);
    }
    closeModal();
  }

  return { savePhaseForm };
}
